export type AttributionParams = { pref?: string; voucher?: string; referrer: string };

/** Mirrors the middleware's x-pref / x-voucher headers, which only exist on the server path. */
export function readAttributionParams(search: string, referrer: string): AttributionParams {
  const params = new URLSearchParams(search);

  return {
    pref: params.get('p_ref') || undefined,
    voucher: params.get('voucher') || undefined,
    referrer,
  };
}
